import axios from '../../helpers/Axios'
import { PatientRecordedEcgWindowType } from './types'
import { GET_API_TOKEN, ECG_API_BASE_URL } from '../../constants/apiConstants'

const baseUrl = ECG_API_BASE_URL

export const getRecordedEcgWindow = async (
  patientKey: string,
  startTime: number,
  endTime: number
): Promise<PatientRecordedEcgWindowType[]> => {
  return axios({
    method: 'get',
    baseURL: baseUrl,
    url: `/api/ecg/snapshot/${patientKey}/window/${startTime}/${endTime}`,
    headers: {
      Authorization: `Bearer ${GET_API_TOKEN()}`
    }
  })
}
